module.exports = __webpack_public_path__ + "img/download-app-store.213694e1.png";